import { StreamService } from './../services/stream.service';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, Inject, Optional } from "@angular/core";
import { tap } from 'rxjs/operators';
import { UserService } from '../services';

@Component({
    template: `
        <div mat-dialog-title>Create Topic</div>
        <div mat-dialog-content [formGroup]="form">
            <mat-form-field>
                <input matInput placeholder="Topic Name" formControlName="name">
                <mat-error *ngIf="form.get('name').hasError('required')">Topic Name is required.</mat-error>
            </mat-form-field>
        </div>
        <div mat-dialog-actions>
            <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="save()">Save</button>
            <button mat-button mat-dialog-close>Cancel</button>
        </div>
    `
})
export class AddEmptyTopicDialogComponent {
    form: FormGroup;
    isShared: boolean;

    constructor(private dialogRef: MatDialogRef<AddEmptyTopicDialogComponent>, 
                fb: FormBuilder,
                @Optional() @Inject(MAT_DIALOG_DATA) data: { topicName: string, isShared: boolean },
                private streamService: StreamService,
                private userService: UserService) {
        this.isShared = data?.isShared;
        this.form = fb.group({ name: fb.control(data?.topicName, Validators.required)});
    }

    save = () => {
        const stream = {
            title: this.form.get('name').value,
            type: 'COLLECTION',
            openForReading: true,
            published: false
        };
        (this.isShared ? this.streamService.saveCatalogStream(stream) :  this.streamService.saveStream(stream)).pipe(
            tap(stream => this.streamService.setSubscription(stream.id, this.userService.getCurrentUser().id, true, false, false).subscribe())
        ).subscribe(stream => this.dialogRef.close(stream.id));
    }
}    
